package com.heelion.farmafreelance.models

import kotlinx.serialization.Serializable
import kotlinx.datetime.Instant

@Serializable
data class Preferito(
    val id: String? = null,
    val utenteId: String,       // L'ID di chi mette il preferito
    val targetId: String,       // L'ID del profilo preferito
    val targetRuolo: String,    // FARMACIA o FARMACISTA
    val createdAt: Instant? = null,

)
